module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.data) ? _c('div', {
    staticClass: "wdqb-box"
  }, [_c('div', {
    staticClass: "wdqb-content"
  }, [_c('div', {
    staticClass: "wdqb-left"
  }, [_c('div', {
    staticClass: "wdqb-coin-card"
  }, [_c('img', {
    staticClass: "wdqb-coin-icon",
    attrs: {
      "src": _vm.data.currencyLogo,
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "wdqb-coin-info"
  }, [_c('span', {
    staticClass: "wdqb-coin-name"
  }, [_vm._v(_vm._s(_vm.data.currencyName))]), _vm._v(" "), _c('span', {
    staticClass: "wdqb-coin-desc"
  }, [_vm._v(_vm._s(_vm.$t('all.lianshangbaobishibei')))])])]), _vm._v(" "), _c('div', {
    staticClass: "wdqb-item"
  }, [_c('span', {
    staticClass: "wdqb-item-label"
  }, [_vm._v(_vm._s(_vm.$t('all.zonge')))]), _vm._v(" "), _c('span', {
    staticClass: "wdqb-item-value"
  }, [_vm._v(_vm._s(_vm.data.sumAmount) + " " + _vm._s(_vm.data.currencyName))])]), _vm._v(" "), _c('div', {
    staticClass: "wdqb-item"
  }, [_c('span', {
    staticClass: "wdqb-item-label"
  }, [_vm._v(_vm._s(_vm.$t('all.keyongshuliang')))]), _vm._v(" "), _c('span', {
    staticClass: "wdqb-item-value"
  }, [_vm._v(_vm._s(_vm.data.sumAvailableAmount) + " " + _vm._s(_vm.data.currencyName))])]), _vm._v(" "), _c('div', {
    staticClass: "wdqb-item"
  }, [_c('span', {
    staticClass: "wdqb-item-label"
  }, [_vm._v(_vm._s(_vm.$t('all.dongjieshuliang')))]), _vm._v(" "), _c('span', {
    staticClass: "wdqb-item-value"
  }, [_vm._v(_vm._s(_vm.data.sumFreezeAmount) + " " + _vm._s(_vm.data.currencyName))])]), _vm._v(" "), _c('div', {
    staticClass: "wdqb-actions"
  }, [_c('div', {
    class: _vm.activeTab === 'deposit' ? 'wdqb-action-btn wdqb-action-gradient' : 'wdqb-action-btn',
    on: {
      "click": _vm.handleSwitchDeposit
    }
  }, [_vm._v(_vm._s(_vm.$t('all.chongbi')))]), _vm._v(" "), _c('div', {
    class: _vm.activeTab === 'withdraw' ? 'wdqb-action-btn wdqb-action-gradient' : 'wdqb-action-btn',
    on: {
      "click": _vm.handleSwitchWithdraw
    }
  }, [_vm._v(_vm._s(_vm.$t('all.tibi')))])]), _vm._v(" "), _c('div', {
    staticClass: "wdqb-flow-btn",
    on: {
      "click": _vm.handleGoFlow
    }
  }, [_vm._v(_vm._s(_vm.$t('all.chakanliushui')))])]), _vm._v(" "), (_vm.activeTab) ? _c('div', {
    staticClass: "wdqb-right"
  }, [_c('div', {
    staticClass: "wd-right-scroll"
  }, [(_vm.activeTab === 'deposit') ? [_c('div', {
    staticClass: "wdqb-right-item",
    on: {
      "click": function($event) {
        _vm.showCurrencyPicker = true
      }
    }
  }, [_c('span', {
    staticClass: "wdqb-right-label"
  }, [_vm._v(_vm._s(_vm.$t('all.xuanzebizhong')))]), _vm._v(" "), _c('div', {
    staticClass: "wdqb-right-item-right"
  }, [_c('span', {
    staticClass: "wdqb-right-value"
  }, [_vm._v(_vm._s(_vm.currentCurrencyName))]), _vm._v(" "), _c('img', {
    staticClass: "wdqb-right-arrow",
    attrs: {
      "src": require("../../../assets/image/quqianbao@2x.png"),
      "alt": ""
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "wdqb-right-item"
  }, [_c('span', {
    staticClass: "wdqb-right-label"
  }, [_vm._v(_vm._s(_vm.$t('all.wangluo')))]), _vm._v(" "), (_vm.data.rechargeNetworkConfigList && _vm.data.rechargeNetworkConfigList[0]) ? _c('span', {
    staticClass: "wdqb-right-value wdqb-text-green"
  }, [_vm._v(_vm._s(_vm.data.rechargeNetworkConfigList[0].symbol))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "wdqb-right-tip"
  }, [_vm._v(_vm._s(_vm.$t('all.chongzhitip')))]), _vm._v(" "), _c('div', {
    staticClass: "wdqb-right-item"
  }, [_c('span', {
    staticClass: "wdqb-right-label"
  }, [_vm._v(_vm._s(_vm.$t('all.chongbidizhi')))]), _vm._v(" "), _c('div', {
    staticClass: "wdqb-right-item-right"
  }, [_c('span', {
    staticClass: "wdqb-right-value wdqb-text-green",
    attrs: {
      "title": _vm.rechargeData.address
    }
  }, [_vm._v(_vm._s(_vm.rechargeData.address))]), _vm._v(" "), _c('img', {
    staticClass: "wdqb-right-copy-img",
    attrs: {
      "src": require("../../../assets/image/fuzhi_18@2x.png"),
      "alt": ""
    },
    on: {
      "click": _vm.handleCopyAddress
    }
  })])]), _vm._v(" "), (_vm.rechargeData.address) ? _c('div', {
    staticClass: "wdqb-qr"
  }, [_c('canvas', {
    ref: "qrcodeCanvas",
    staticClass: "wdqb-qr-canvas"
  })]) : _vm._e(), _vm._v(" "), (_vm.agreementContent) ? _c('div', {
    staticClass: "wdqb-right-agreement",
    domProps: {
      "innerHTML": _vm._s(_vm.agreementContent)
    }
  }) : _vm._e()] : _vm._e(), _vm._v(" "), (_vm.activeTab === 'withdraw') ? [_c('div', {
    staticClass: "wdqb-right-item"
  }, [_c('span', {
    staticClass: "wdqb-right-label"
  }, [_vm._v(_vm._s(_vm.$t('all.tibidizhi')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.withdrawAddress),
      expression: "withdrawAddress"
    }],
    staticClass: "wdqb-right-input",
    attrs: {
      "placeholder": _vm.$t('all.qingshurutibidizhi')
    },
    domProps: {
      "value": (_vm.withdrawAddress)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.withdrawAddress = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "wdqb-right-item"
  }, [_c('span', {
    staticClass: "wdqb-right-label"
  }, [_vm._v(_vm._s(_vm.$t('all.wangluo')))]), _vm._v(" "), _c('span', {
    staticClass: "wdqb-right-value"
  }, [_vm._v(_vm._s(_vm.data.withdrawalNetworkConfigList && _vm.data.withdrawalNetworkConfigList[0] ? _vm.data.withdrawalNetworkConfigList[0].symbol : ''))])]), _vm._v(" "), _c('div', {
    staticClass: "wdqb-right-item"
  }, [_c('span', {
    staticClass: "wdqb-right-label"
  }, [_vm._v(_vm._s(_vm.$t('all.tibishuliang')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.withdrawAmount),
      expression: "withdrawAmount"
    }],
    staticClass: "wdqb-right-input",
    attrs: {
      "placeholder": _vm.$t('all.qingshuru')
    },
    domProps: {
      "value": (_vm.withdrawAmount)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.withdrawAmount = $event.target.value
      }
    }
  })]), _vm._v(" "), (_vm.data.withdrawalNetworkConfigList && _vm.data.withdrawalNetworkConfigList[0] && _vm.data.withdrawalNetworkConfigList[0].minWithdrawalAmount) ? _c('div', {
    staticClass: "wdqb-right-min-tip"
  }, [_vm._v(_vm._s(_vm.$t('all.zuiditixianjin')) + _vm._s(_vm.data.withdrawalNetworkConfigList[0].minWithdrawalAmount) + " " + _vm._s(_vm.data.currencyName))]) : _vm._e(), _vm._v(" "), (_vm.withdrawError) ? _c('div', {
    staticClass: "wdqb-right-error"
  }, [_vm._v(_vm._s(_vm.withdrawError))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "wdqb-right-estimate"
  }, [_c('div', {
    staticClass: "wdqb-right-estimate-header"
  }, [_c('span', {
    staticClass: "wdqb-right-estimate-title"
  }, [_vm._v(_vm._s(_vm.$t('all.tibishisuan')))]), _vm._v(" "), _c('span', {
    staticClass: "wdqb-right-estimate-tag"
  }, [_vm._v(_vm._s(_vm.$t('all.shouxufeibilv')) + _vm._s(_vm.data.withdrawalNetworkConfigList && _vm.data.withdrawalNetworkConfigList[0] ? _vm.data.withdrawalNetworkConfigList[0].withdrawalServiceChargeRatio : 0))])]), _vm._v(" "), _c('div', {
    staticClass: "wdqb-right-estimate-row"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('all.shouxufei')))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.withdrawFee) + " " + _vm._s(_vm.data.currencyName))])]), _vm._v(" "), _c('div', {
    staticClass: "wdqb-right-estimate-row"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('all.shijidaozhang')))]), _vm._v(" "), _c('span', {
    staticClass: "wdqb-text-green"
  }, [_vm._v(_vm._s(_vm.withdrawActual) + " " + _vm._s(_vm.data.currencyName))])])]), _vm._v(" "), _c('div', {
    staticClass: "wdqb-right-btn",
    on: {
      "click": _vm.handleWithdraw
    }
  }, [_vm._v(_vm._s(_vm.$t('all.tijiaotibi')))])] : _vm._e()], 2), _vm._v(" "), (_vm.activeTab === 'deposit' && _vm.data.rechargeNetworkConfigList && _vm.data.rechargeNetworkConfigList[0]) ? _c('div', {
    staticClass: "wdqb-right-min-tip wdqb-right-min-tip--fixed"
  }, [_vm._v(_vm._s(_vm.$t('all.zuidicharge')) + _vm._s(_vm.data.rechargeNetworkConfigList[0].minRechargeAmount) + " " + _vm._s(_vm.data.currencyName) + "，" + _vm._s(_vm.$t('all.xiaoyuzuixiaoe')))]) : _vm._e()]) : _vm._e()]), _vm._v(" "), (_vm.showAddressModal) ? _c('div', {
    staticClass: "wdqb-overlay",
    on: {
      "click": function($event) {
        _vm.showAddressModal = false
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showAddressModal) ? _c('div', {
    staticClass: "wdqb-address-modal",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "wdqb-address-title"
  }, [_vm._v(_vm._s(_vm.$t('all.xuanzetibidizhi')))]), _vm._v(" "), _c('div', {
    staticClass: "wdqb-address-search"
  }, [_c('img', {
    staticClass: "wdqb-address-search-icon",
    attrs: {
      "src": require("../../../assets/image/sousuo_18@2x.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchAddress),
      expression: "searchAddress"
    }],
    staticClass: "wdqb-address-search-input",
    attrs: {
      "placeholder": _vm.$t('all.sousuodizhi')
    },
    domProps: {
      "value": (_vm.searchAddress)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchAddress = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "wdqb-address-list"
  }, _vm._l((_vm.addressList), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "wdqb-address-item"
    }, [_c('div', {
      staticClass: "wdqb-address-item-info"
    }, [_c('span', {
      staticClass: "wdqb-address-item-label"
    }, [_vm._v(_vm._s(item.label))]), _vm._v(" "), _c('span', {
      staticClass: "wdqb-address-item-value"
    }, [_vm._v(_vm._s(item.address))])]), _vm._v(" "), _c('div', {
      staticClass: "wdqb-address-item-btn",
      on: {
        "click": function($event) {
          return _vm.handleSelectAddress(item)
        }
      }
    }, [_vm._v(_vm._s(_vm.$t('all.xuanze')))])])
  }), 0)]) : _vm._e(), _vm._v(" "), (_vm.showCurrencyPicker) ? _c('div', {
    staticClass: "wdqb-overlay",
    on: {
      "click": function($event) {
        _vm.showCurrencyPicker = false
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showCurrencyPicker) ? _c('div', {
    staticClass: "wdqb-currency-modal",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "wdqb-currency-title"
  }, [_vm._v(_vm._s(_vm.$t('all.xuanzebizhong')))]), _vm._v(" "), _c('div', {
    staticClass: "wdqb-currency-list"
  }, _vm._l((_vm.currencyList), function(item, index) {
    return _c('div', {
      key: item.currencyId,
      staticClass: "wdqb-currency-item",
      class: {
        'wdqb-currency-item--active': String(item.currencyId) === String(_vm.currencyId)
      },
      on: {
        "click": function($event) {
          return _vm.onCurrencyConfirm(item)
        }
      }
    }, [_c('img', {
      staticClass: "wdqb-currency-item-icon",
      attrs: {
        "src": item.currencyLogo,
        "alt": ""
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "wdqb-currency-item-name"
    }, [_vm._v(_vm._s(item.unitText || item.currencyName))]), _vm._v(" "), (String(item.currencyId) === String(_vm.currencyId)) ? _c('span', {
      staticClass: "wdqb-currency-item-check"
    }, [_vm._v("✓")]) : _vm._e()])
  }), 0)]) : _vm._e(), _vm._v(" "), (_vm.showVerifyModal) ? _c('div', {
    staticClass: "wdqb-overlay",
    on: {
      "click": _vm.closeVerify
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showVerifyModal) ? _c('div', {
    staticClass: "wdqb-verify-modal",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "wdqb-verify-header"
  }, [_c('span', {
    staticClass: "wdqb-verify-title"
  }, [_vm._v(_vm._s(_vm.$t('all.anquanyanzheng')))]), _vm._v(" "), _c('img', {
    staticClass: "wdqb-verify-close",
    attrs: {
      "src": require("../../../assets/image/tanchuang_x_b@2x.png"),
      "alt": ""
    },
    on: {
      "click": _vm.closeVerify
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "wdqb-verify-section"
  }, [_c('span', {
    staticClass: "wdqb-verify-label"
  }, [_vm._v(_vm._s(_vm.$t('all.youxiang')))]), _vm._v(" "), _c('div', {
    staticClass: "wdqb-verify-box"
  }, [_c('span', {
    staticClass: "wdqb-verify-email"
  }, [_vm._v(_vm._s(_vm.userEmail))])])]), _vm._v(" "), _c('div', {
    staticClass: "wdqb-verify-section"
  }, [_c('span', {
    staticClass: "wdqb-verify-label"
  }, [_vm._v(_vm._s(_vm.$t('all.yanzhengma')))]), _vm._v(" "), _c('div', {
    staticClass: "wdqb-verify-box wdqb-verify-code-row"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.emailCode),
      expression: "emailCode"
    }],
    staticClass: "wdqb-verify-input",
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('all.qingshuruyouxiangyanzhengma')
    },
    domProps: {
      "value": (_vm.emailCode)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.emailCode = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "wdqb-verify-send",
    class: {
      'wdqb-verify-send--disabled': _vm.codeCountdown > 0
    },
    on: {
      "click": _vm.sendEmailCode
    }
  }, [_vm._v("\n            " + _vm._s(_vm.codeCountdown > 0 ? _vm.codeCountdown + 's' : _vm.$t('all.fasongyanzhengma')) + "\n          ")])])]), _vm._v(" "), _c('div', {
    staticClass: "wdqb-verify-confirm",
    on: {
      "click": _vm.confirmVerifyAndWithdraw
    }
  }, [_vm._v(_vm._s(_vm.$t('all.queren')))])]) : _vm._e(), _vm._v(" "), (_vm.showWithdrawSuccess) ? _c('div', {
    staticClass: "wdqb-overlay",
    on: {
      "click": function($event) {
        _vm.showWithdrawSuccess = false
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showWithdrawSuccess) ? _c('div', {
    staticClass: "wdqb-success-modal",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "wdqb-success-icon"
  }, [_c('svg', {
    attrs: {
      "viewBox": "0 0 24 24",
      "width": "48",
      "height": "48"
    }
  }, [_c('path', {
    attrs: {
      "d": "M9 16.2L4.8 12l-1.4 1.4L9 19 21 7l-1.4-1.4L9 16.2z",
      "fill": "#FFFFFF"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "wdqb-success-title"
  }, [_vm._v(_vm._s(_vm.$t('all.tibishenqingyitijiao') || '提币申请已提交'))]), _vm._v(" "), _c('div', {
    staticClass: "wdqb-success-desc"
  }, [_vm._v(_vm._s(_vm.$t('all.tibishenqingdesc') || '后台审核通过后，将进行链上提币。'))]), _vm._v(" "), _c('div', {
    staticClass: "wdqb-success-row"
  }, [_c('span', {
    staticClass: "wdqb-success-row-label"
  }, [_vm._v(_vm._s(_vm.$t('all.zhuangtai') || '状态'))]), _vm._v(" "), _c('span', {
    staticClass: "wdqb-success-row-value"
  }, [_vm._v(_vm._s(_vm.withdrawSuccessStatus || (_vm.$t('all.shenhezhong') || '审核中')))])]), _vm._v(" "), _c('div', {
    staticClass: "wdqb-success-row"
  }, [_c('span', {
    staticClass: "wdqb-success-row-label"
  }, [_vm._v(_vm._s(_vm.$t('all.shijidaozhang') || '实际到账'))]), _vm._v(" "), _c('span', {
    staticClass: "wdqb-success-row-value"
  }, [_vm._v(_vm._s(_vm.withdrawSuccessActual) + " " + _vm._s(_vm.data.currencyName))])]), _vm._v(" "), _c('div', {
    staticClass: "wdqb-success-btn",
    on: {
      "click": _vm.handleGoFlow
    }
  }, [_vm._v(_vm._s(_vm.$t('all.chakantibi') || '查看提币记录'))])]) : _vm._e()]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4ae76454"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/pages/wodequanbao/wodequanbao.vue
// module id = 1016
// module chunks = 1